import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  // Kurz warten bis der AuthContext den localStorage gelesen hat
  if (loading) return null;

  // Nicht eingeloggt → zur Login-Seite umleiten
  if (!user) return <Navigate to="/login" replace />;

  return children;
}
